// Stats: the finished play as a table. Puzzle: time, words per minute, extra
// words, the longest constellation, words returned. Apogee: time, words per
// minute, stars per constellation, score per word, the best word, stars
// used and the planet ringed. Assemblage: time, words per minute, stars per
// constellation, the longest constellation, words returned.
import { formatDuration, formatRate, type PlayStats } from '../../../systems/play/playStats';

type Row = { label: string; value: string; sub?: string };

export function StatsTable({ stats }: { stats: PlayStats }) {
  const rows: Row[] = [];
  const time = stats.elapsedMs !== null ? formatDuration(stats.elapsedMs) : '—';
  rows.push({ label: 'Time', value: time });
  rows.push({ label: 'Words per minute', value: stats.wordsPerMinute !== null ? formatRate(stats.wordsPerMinute) : '—' });
  if (stats.mode === 'puzzle') {
    rows.push({ label: 'Extra words', value: String(stats.extraWords.length), sub: stats.extraWords.length > 0 ? stats.extraWords.join(' · ') : undefined });
    if (stats.longest) rows.push({ label: 'Longest constellation', value: `${stats.longest.stars} stars`, sub: stats.longest.word });
    rows.push({ label: 'Returned to the stars', value: String(stats.returned) });
  } else if (stats.mode === 'assemblage') {
    rows.push({ label: 'Stars / constellation', value: stats.starsPerConstellation !== null ? formatRate(stats.starsPerConstellation) : '—' });
    if (stats.longest) rows.push({ label: 'Longest constellation', value: `${stats.longest.stars} stars`, sub: stats.longest.word });
    rows.push({ label: 'Returned to the stars', value: String(stats.returned) });
  } else {
    rows.push({ label: 'Stars / constellation', value: stats.starsPerConstellation !== null ? formatRate(stats.starsPerConstellation) : '—' });
    rows.push({ label: 'Score / word', value: stats.scorePerWord !== null ? formatRate(stats.scorePerWord) : '—' });
    if (stats.best) rows.push({ label: 'Best word', value: `+${stats.best.total}`, sub: stats.best.word });
    rows.push({ label: 'Stars used', value: `${stats.starsUsed} / ${stats.starsTotal}` });
    if (stats.planetsTotal === 1) rows.push({ label: 'Planet ringed', value: stats.planetsRinged === 1 ? 'Yes' : 'No' });
    else if (stats.planetsTotal > 1) rows.push({ label: 'Planets ringed', value: `${stats.planetsRinged} / ${stats.planetsTotal}` });
  }
  return (
    <table className="stats-table">
      <tbody>
        {rows.map((r) => (
          <tr key={r.label}>
            <th scope="row">
              {r.label}
              {r.sub && <span className="stats-sub mono">{r.sub}</span>}
            </th>
            <td className="mono">{r.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
